export const filterEmptyValues = (obj) => {
  if (typeof obj !== "object" || obj === null) return obj;

  // Check if the object is an array
  if (Array.isArray(obj)) {
    return obj
      .map(filterEmptyValues)
      .filter((item) => item !== undefined && item !== null);
  }

  // Process objects
  const filteredObj = Object.entries(obj).reduce((acc, [key, value]) => {
    const processedValue =
      typeof value === "object" ? filterEmptyValues(value) : value;

    // Ensure we keep non-empty objects, non-empty arrays, numbers, booleans, and strings
    if (
      processedValue !== undefined &&
      processedValue !== null &&
      (typeof processedValue !== "object" ||
        Object.keys(processedValue).length > 0)
    ) {
      acc[key] = processedValue;
    }

    return acc;
  }, {});

  return Object.keys(filteredObj).length > 0 ? filteredObj : undefined;
};
